<template>
  <div class="wrapper">
    <img src="~@/assets/img/float-linear.png" alt="">
    <div class="bar" ref="bar" :class="{'is-fixed': isOutOfPort}">
      <div class="bar-item"
      :class="[index === activeIndex ? 'is-active' : '', `bar-item-${index}`]"
      v-for="(item ,index) in branchList" :key="index"
      @click="barHandler(item.id, index)">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import VueBus from '@/utils/vueBus'

export default {
  data () {
    return {
      activeIndex: 0,
      isOutOfPort: false,
      itemScrollTopInfo: []
      // isOpen: false
    }
  },
  props: ['branchList'],
  created () {
  },
  mounted () {
    // 父元素的高度
    const barEle = document.querySelector('.bar')
    const barHeight = barEle.offsetHeight
    // 每个 item 的高度
    document.querySelectorAll('.bar-item').forEach(ele => {
      this.itemScrollTopInfo.push(ele.offsetTop + ele.offsetHeight / 2 - barHeight / 2)
    })

    VueBus.$on('setTargetIndex', this.scrollToTargetBranchHandler)

    if (this.$refs.bar && this.$refs.bar.getBoundingClientRect().left < 0) this.isOutOfPort = true
  },
  methods: {
    /**
     * 滚动到对应的 分会
     * @param {index} Number 对应 bar 的 索引值
     */
    barHandler (id, index) {
      this.activeIndex = index

      VueBus.$emit('scrollToTargetBranch', id)

      document.querySelector('.bar').scrollTop = this.itemScrollTopInfo[index]
      // this.$scrollTo(`.bar-item-${index}`, 100, { container: '.bar', offset: -document.querySelector('.bar').offsetHeight / 2 + document.querySelector('.bar-item').offsetHeight / 2 })
    },
    // mouseOverHandler ($event) {
    //   console.log($event)
    // },
    scrollToTargetBranchHandler (index) {
      this.activeIndex = index

      if (document.querySelector('.bar')) document.querySelector('.bar').scrollTop = this.itemScrollTopInfo[index]
      // this.$scrollTo(`.bar-item-${index}`, 100, { container: '.bar', offset: -document.querySelector('.bar').offsetHeight / 2 + document.querySelector('.bar-item').offsetHeight / 2 })
    }
  },
  beforeDestroy () {
    VueBus.$off('setTargetIndex', this.scrollToTargetBranchHandler)
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.wrapper {
  width: 102px;
  position: fixed; left: 0px; top: 25vh;
  transition: all 0.3s linear;
  z-index: 100;
  box-shadow: 0 4px 8px 0 rgba(7,17,27,.1);
  background: rgba(#fff, 1);
  border-radius:3px;
  &.is-open {
    left: 10px;
  }
  img {
    display: block;
    width: 72px;
    margin: 0 auto;
  }
  @media screen and (min-width: 1600px) {
    left: 50%;
    transform: translateX(calc(-680px - 100%))
  }
}
.bar {
  padding: 10px 10px;
  // max-height: 50vh;
  // overflow-y: scroll;
  z-index: 999;
  cursor: pointer;
  transition: all 0.3s linear;
  scroll-behavior: smooth;
  text-align: center;

  // 去掉滚动条 start
  scrollbar-width: none;
   -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  // 去掉滚动条 end

  .bar-item {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #5F6368;
    line-height: 2.5;
    text-align: center;
    padding: 2px 0;
    // margin: 6px 0;
    transition: all 0.3s linear;

    &:hover {
      color: #3976FF;
    }
  }

  .is-active {
    // background: rgba(215,179,117,0.1);
    color: #3976FF;
    font-weight: 500;
  }

  img {
    width: 89%;
    display: inline;
    margin-top: 5px;
  }

}
</style>
